export default "__VITE_ASSET__BM7t$dce__"